<template>
	<div>
		<div v-for="(link, index) in linksToShow" :key="index" >
			<el-tooltip
				class="item"
				effect="dark"
				:content="`${link.event_type}: ${format(new Date(link.last_event_timestamp), 'd/MM/yyyy - HH:mm')}`"
				placement="top"
			>
				<svg-icon :icon-class="link.event_type | eventsTypeIconFilter"></svg-icon>
			</el-tooltip>
		</div>
	</div>
</template>
<script>
import { format } from 'date-fns';

export default {
	name: 'InterchangeLinks',
	components: {
	},
	props: {
		links: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			format: format
		};
	},
	computed: {
		linksToShow() {
			let allLinks = this.links
				.flatMap(il => il.interchange_by_reference.interchange_events ? il.interchange_by_reference.interchange_events : [])
				.sort((a, b) => a.last_event_timestamp < b.last_event_timestamp);
			var linksToShow = [];
			var eventTypes = [];
			for (const link of allLinks) {
				if (!eventTypes.includes(link.event_type)) {
					linksToShow.push(link);
					eventTypes.push(link.event_type);
				}
			}
			return linksToShow;
		}
	}
};
</script>
<style lang="scss">
</style>
